import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import { SlayersBattalionEffect } from 'generic_rules/core_battalions'
import { OneDropDeploymentEffect } from 'generic_rules/core_rules'

const Battalions = {
 /* 'Castelite Formation': {
    effects: [OneDropDeploymentEffect, SlayersBattalionEffect],
  }, */
} satisfies TItemDescriptions

export default tagAs(Battalions, 'battalion')
